import React, { useEffect } from 'react';
import '../styles/term-of-service.css';
import { useSettings } from '../context/SettingsContext';

const PrivacyPolicyPage = () => {
    const { privacyPolicy } = useSettings();

    useEffect(() => {
        document.title = 'Iampesmobile - Chính sách bảo mật';
    }, []);

    return (
        <div className="tos-page-shell">
            <section className="tos-page-hero">
                <p className="tos-page-kicker">Legal & Policy</p>
                <h1 className="tos-page-title">Chính Sách Bảo Mật</h1>
                <p className="tos-page-subtitle">
                    Cách iampesmobile thu thập, lưu trữ và sử dụng dữ liệu để bảo vệ thông tin người dùng.
                </p>
            </section>

            <section className="tos-page-content">
                {privacyPolicy.map((term, index) => (
                    <article key={term.id || index} className="tos-page-item">
                        <h2 className="tos-page-item-title">{term.title}</h2>
                        <p className="tos-page-item-content">{term.content}</p>
                    </article>
                ))}
            </section>
        </div>
    );
};

export default PrivacyPolicyPage;
